import some from "lodash/some";
import { buildProfilesOptionsFetcher } from "PFApp/helpers/options/profiles_options";
import { Select } from "PFComponents/select";
import { BasicProfile } from "PFTypes";
import { Id } from "PFTypes/id";
import { Option } from "PFTypes/options";
import { useTranslation } from "react-i18next";

import css from "./vacancy.module.scss";

type CandidateSelectProps = {
  candidateId: number;
  selectedProfileIds: Id[];
  onCandidateChange: (value: number | null) => void;
};

export const CandidateSelect = ({
  candidateId,
  selectedProfileIds,
  onCandidateChange
}: CandidateSelectProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "show.vacancies" });

  return (
    <Select
      className={css.columnItem}
      label={t("workforceMember")}
      onChange={(profile: Option<BasicProfile>) => onCandidateChange(Number(profile.id))}
      value={candidateId ? Number(candidateId) : undefined}
      fetchOptions={buildProfilesOptionsFetcher({
        renderDisplayElement: (profile) => profile.text,
        getDisabled: (profile) => some(selectedProfileIds, (id) => id === String(profile.id))
      })}
    />
  );
};
